// src/index.js or src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import DashboardApp from './DashboardApp';
import './index.css'; // your styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<DashboardApp />);
